import ContractService from "@/services/contract.service";
import { IDownloadPopupTicket } from "@/services/download-popup.service";
import {
  IContract,
  IContractSocketMessage,
  IDownloadBackLinkSocketMessage,
  IDownloadSearchContentSocketMessage,
  ISearchContentSocketMessage,
  IUpdateSearchHistorySocketMessage,
  ISearchLinkSocketMessage,
  IVerifySocketMessage,
  RootState,
  IBackLinkSearchSocketMessage,
} from "@/types";
import Vuex from "vuex";

const state: RootState = {
  isInitialized: false,
  isAuth: false,
  starBridgeJWTToken: "",
  lcToken: "",
  wsController: null,
  wsSCController: null,
  wsSCRController: null,
  wsConnectionId: "",
  wsSCConnectionId: "",
  wsSCRConnectionId: "",
  contract: null,
  verificationSocketData: null,
  contractSocketData: null,
  searchContentSocketData: null,
  searchContentReportSocketData: null,
  downloadSearchContentReportSocketData: null,
  downloadBacklinkSocketData: null,
  backlinkSearchSocketData: null,
  searchLinkSocketData: null,
  user: null,
  isAdminApp: window.location.pathname.startsWith("/sys-admin"),
  dialogs: {
    unexpectedError: false,
  },
  searchHistorySocketData: {},
  listDownloadPopup: [],
};

export default new Vuex.Store({
  state,
  getters: {
    isInitialized: (state) => state.isInitialized,
    isAuth: (state) => state.isAuth,
    starBridgeJWTToken: (state) => state.starBridgeJWTToken,
    lcToken: (state) => state.lcToken,
    contract: (state) => state.contract as IContract,
    wsConnectionId: (state) => state.wsConnectionId,
    wsSCConnectionId: (state) => state.wsSCConnectionId,
    wsSCRConnectionId: (state) => state.wsSCRConnectionId,
    wsController: (state) => state.wsController as WebSocket,
    wsSCController: (state) => state.wsSCController,
    wsSCRController: (state) => state.wsSCRController,
    verificationSocketData: (state) => state.verificationSocketData as IVerifySocketMessage,
    contractSocketData: (state) => state.contractSocketData,
    searchContentSocketData: (state) => state.searchContentSocketData,
    searchContentReportSocketData: (state) => state.searchContentReportSocketData,
    downloadSearchContentReportSocketData: (state) => state.downloadSearchContentReportSocketData,
    downloadBacklinkSocketData: (state) => state.downloadBacklinkSocketData,
    backlinkSearchSocketData: (state) => state.backlinkSearchSocketData,
    searchLinkSocketData: (state) => state.searchLinkSocketData,
    user: (state) => state.user,
    isAdminApp: (state) => state.isAdminApp,
    searchHistorySocketData: (state) => state.searchHistorySocketData,
    listDownloadPopup: (state) => state.listDownloadPopup,
  },
  mutations: {
    setState(state, nextState) {
      Object.keys(nextState).forEach((key) => ((state as any)[key as keyof RootState] = nextState[key]));
    },
    showDialog(state, dialogState: { name: string; value?: boolean }) {
      const value = dialogState.value === undefined ? true : dialogState.value;
      (state as any).dialogs[dialogState.name] = value;
    },
    addDownloadPopup(state, ticket: IDownloadPopupTicket) {
      state.listDownloadPopup.unshift(ticket);
    },
    removeDownloadPopup(state, id: string) {
      state.listDownloadPopup = state.listDownloadPopup.filter((ticket) => ticket.SK !== id);
    },
    handleUpdateSearchHistory(state, data: IUpdateSearchHistorySocketMessage) {
      state.searchHistorySocketData[data.searchId] = {
        status: data.status,
        detectionCount: data.detectionCount,
        numberOfPages: data.numberOfPages,
      };
    },
    removeSearchHistory(state, searchId: string) {
      delete state.searchHistorySocketData[searchId];
    },
  },
  actions: {
    signIn({ commit }, { user }) {
      commit("setState", { user: user });
    },
    signOut({ commit }) {
      commit("setState", { user: null });
    },
    handleVerificationSocket({ commit }, data: IVerifySocketMessage) {
      commit("setState", { verificationSocketData: data });
    },
    handleContractSocket({ commit }, data: IContractSocketMessage) {
      commit("setState", { contractSocketData: data });
    },
    handleSearchContentResultSocket({ commit }, data: ISearchContentSocketMessage) {
      commit("setState", { searchContentSocketData: data });
    },
    handleSearchContentReportSocket({ commit }, data: ISearchContentSocketMessage) {
      commit("setState", { searchContentReportSocketData: data });
    },
    handleDownloadSearchContents({ commit }, data: IDownloadSearchContentSocketMessage) {
      commit("setState", { downloadSearchContentReportSocketData: data });
    },
    handleDownloadBackLink({ commit }, data: IDownloadBackLinkSocketMessage) {
      commit("setState", { downloadBacklinkSocketData: data });
    },
    handleBacklinkSearch({ commit }, data: IBackLinkSearchSocketMessage) {
      commit("setState", { backlinkSearchSocketData: data });
    },
    handleSearchLinkResults({ commit }, data: ISearchLinkSocketMessage) {
      commit("setState", { searchLinkSocketData: data });
    },
    async refreshContractQuotas({ commit }) {
      const contractId = this.state.contract?.contractId;
      const serviceGroupId = this.state.contract?.serviceGroupId;
      if (contractId && serviceGroupId) {
        const contract = await ContractService.getContract({ contractId, serviceGroupId });
        if (contract) commit("setState", { contract: contract });
      }
    },
  },
  modules: {},
});
